export enum PartnershipType {
    Rational = 1,
    AccountingOutsourcing = 2,
    Others = 3,
    StayCalm = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/PartnershipType.ts